<template>
  <section class="services">
    <div class="service" :class="type" v-for="(item, key) in items" :key="key">
      <Field
        type="radio"
        :name="type"
        :value="item.id"
        :id="`${type}-${item.id}`"
        rules="required"
        v-model="id"
        @change="changedInput(item)"
      />
      <div class="text">
        <label :for="`${type}-${item.id}`">
          {{ item.name }}
          <span v-if="showPrice(item)" class="addition">
            {{ additionText(item) }}
          </span>
          <span v-else class="addition">
            {{ $t("Free") }}
          </span>
        </label>
        <Packeta v-if="isPacketa(item.id)" :shipping="item" />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import useCart from "../useCart";
import { Field } from "vee-validate";
import store from "../../../store";
import Packeta from "../../../packages/views/packeta/Button";
import { packetaId } from "../../../../config";

export default {
  components: {
    Packeta,
    Field,
  },
  props: {
    items: {
      type: Array,
    },
    type: {
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      cartData: "cart/getCartData",
      hasFreeShipping: "cart/getHasFreeShipping",
    }),
  },
  methods: {
    showPrice(item) {
      if(!item.can_free){
        return true;
      }

      if (item.price) { 
        if (this.type === "shipping" && this.hasFreeShipping) {
          return false;
        }
      }

      return true;
    },
    additionText(item) {
      return item.price == 0
        ? this.$t("Free")
        : this.formattedPrice(item.price);
    },
    changedInput(value) {
      this.cartData[this.type] = value;
    },
    isPacketa(id) {
      return this.type === "shipping" && this.packetaId.includes(id);
    },
  },
  setup(props) {
    const entity = store.getters["cart/getCartData"][props.type];
    const id = entity ? entity.id : null;
    const { setCartLocalStorage, formattedPrice } = useCart();

    return {
      packetaId,
      setCartLocalStorage,
      formattedPrice,
      id,
    };
  },
};
</script>
